// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Blocks `modal` completion until `loading` settles, loaded or not; returns `loading`. */
export function holdCompletionUntilLoaded(modal, loading) {
  let ready = false;

  function guardCompletion() {
    if (!ready) {
      modal.abortCompletion();
    }
  }

  function allowCompletion() {
    ready = true;
    modal.enableCompletion();
  }

  modal.disableCompletion();
  modal.on("beforeComplete", guardCompletion);

  return loading.finally(allowCompletion);
}
